import React from "react";
import { Box, Typography, Card, CardContent, Avatar, Stack } from "@mui/material";
import { Person, Cake, Phone } from "@mui/icons-material";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useSelector } from "react-redux";

const StudentDataHeader = () => {

  const {loading, nonCartStudentData} = useSelector((state)=> state.crd)

  const studentData = nonCartStudentData?.student_details;

  return (
    <Card
      sx={{
        width: "100%",
        background: "linear-gradient(135deg, #af4cafff 20%, #2e77c0ff 90%)",
        color: "#fff",
        borderRadius: 3,
        boxShadow: 3,
      }}
    >
      <CardContent>
        <Stack
          direction={{xs:'column',sm:'row'}}
          alignItems="center"
          justifyContent="space-between"
          spacing={4}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Avatar
              sx={{
                bgcolor: "#fff",
                color: "#891c82ff",
                width: 64,
                height: 64,
                fontSize: 24,
                fontWeight: "bold",
              }}
            >
              {studentData?.student_name.charAt(0)}
            </Avatar>
            <Box>
              <Typography variant="h5" fontWeight={600}>
                {studentData?.student_name}
              </Typography>
              <Typography variant="body2" color="rgba(255,255,255,0.8)">
                Student Profile
              </Typography>
            </Box>
          </Stack>

          <Stack direction={{xs:'column',sm:'row'}} spacing={2}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography>Adm NO : </Typography>
              <Typography variant="body1">{studentData?.admn_no || "No Data Available"}</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography>DOB : </Typography>
              <Typography variant="body1">{studentData?.dob || "No Data Available"}</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Icon icon={"mdi:phone"} width={20} height={20}/>
              <Typography variant="body1">{studentData?.student_mob_no || "Not Available"}</Typography>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default StudentDataHeader;
